// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://dknaenuyloqedldcffal.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRrbmFlbnV5bG9xZWRsZGNmZmFsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTgxOTQyNTUsImV4cCI6MjA3Mzc3MDI1NX0.rU_OoV-iXHBXJt11adRgXaXIdwoa1aeYp5rYCwav9fk";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  },
  realtime: {
    params: {
      eventsPerSecond: 1
    }
  },
  global: {
    headers: {
      'x-client-info': 'mystic-forest-app'
    }
  },
  db: {
    schema: 'public'
  }
});